import React from "react";
import { reduxForm, Field } from "redux-form";
import { Row, Col } from "react-bootstrap";
import { update } from "MODULES/RMAsAndWarranties/actions";
import { Form as AppForm, FormInput } from "MODULES/shared/components/Forms";

export function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Row className="row-col-gutters-half">
          <Col md={12}>
            <Field
              name="incoming_awb_number"
              component={FormInput}
              label="AWB #"
            />
          </Col>
        </Row>
      </AppForm.Body>
    </AppForm>
  );
}

export default reduxForm({
  form: "customerRMASection",
  onSubmit: (values, dispatch) => dispatch(update(values))
})(Form);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/CustomerRMASection/Form.jsx